export default "__VITE_ASSET__COIFty7q__"